import { LIFFProfile } from './liff/liff.interface';
import { NormalizedProfile } from './sdk.interface';
import { TalariaProfile } from './talaria/talaria.interface';

const isLIFFProfile = (
  profile: Record<string, string>,
): profile is LIFFProfile =>
  ['userId'].every(key => typeof profile[key] === 'string');

export const normalizedProfile = (
  profile: LIFFProfile | TalariaProfile,
): NormalizedProfile => {
  if (isLIFFProfile(profile)) return profile;
  else {
    const { id, ...rest } = profile;

    return {
      ...rest,
      userId: id,
    };
  }
};
